var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3074_18413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1104",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3074_18413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1110",
    d: "M2.96252 23.2969L12 18.7782L21.0375 23.2969V0.703127H2.96252V23.2969Z",
    stroke: "#9C9EA9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1114",
    d: "M12 12.3484L9.20731 13.8164L9.74084 10.7068L7.48132 8.50448L10.6038 8.05073L12 5.22131L13.3964 8.05073L16.5188 8.50448L14.2595 10.7068L14.7929 13.8164L12 12.3484Z",
    stroke: "#9C9EA9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFavorite);
export default __webpack_public_path__ + "static/media/notFavorite.1026c5d62b9bbcb11275902b70555648.svg";
export { ForwardRef as ReactComponent };